import React, { lazy, Suspense } from 'react';

const RevenueChart = lazy(() => import('./RevenueChart'));

const WrappedRevenueChart = (props) => (
  <Suspense fallback={<div>Loading...</div>}>
    <RevenueChart {...props} />
  </Suspense>
);
export default WrappedRevenueChart;
